import React, { useEffect } from "react";
import TableCell from "../common/ui/TableCell";
import TinyMCEeditor from "../const/TinyMCEeditor";
import TinyMCEpreview from "../const/TinyMCEpreview";

export default function ReviewOpinionDoc({
  editing = false,
  data = {},
  form = {},
  handleChange,
  editorRef,
}) {
  /* --------------------------------
     TinyMCE 초기값 주입 (WorkOrderNew와 동일)
  -------------------------------- */
  useEffect(() => {
    if (!editing) return;

    setTimeout(() => {
      if (editorRef.current) {
        editorRef.current.setContent(data.content || "");
      }
      console.log(data.content)
    }, 200);
  }, [editing, data.content, editorRef]);

  return (
    <div className="text-xs">
      

      {/* ===== 기본 정보 ===== */}
      <table className="w-full table-fixed">
        <tbody>
          <tr>
            <TableCell
              label="검토건명"
              editing={editing}
              value={data.title}
              input={
                <input
                  type="text"
                  name="title"
                  value={form.title || ""}
                  onChange={handleChange}
                  className="input-base"
                />
              }
            />
            <TableCell
              label="보고일자"
              editing={editing}
              value={data.reportDate}
              input={
                <input
                  type="date"
                  name="reportDate"
                  value={form.reportDate || ""}
                  onChange={handleChange}
                  className="input-base"
                />
              }
            />
          </tr>

          {/* ===== 1) 검토목적 ===== */}
          <tr>
            <TableCell
              label="1) 검토목적"
              colSpan={3}
              editing={editing}
              value={<div className="p-1">{data.purpose || "-"}</div>}
              input={
                <textarea
                  name="purpose"
                  value={form.purpose || ""}
                  onChange={handleChange}
                  className="input-base h-28 resize-none"
                />
              }
            />
          </tr>

          {/* ===== 2) 검토내용 (TinyMCE) ===== */}
          <tr>
            <TableCell
              label="2) 검토내용"
              colSpan={3}
              editing={editing}
              value={
                <TinyMCEpreview
                  html={data.content || "<p>검토내용이 없습니다.</p>"}
                />
              }
              input={
                <div className="w-full">
                  {/* ⭐ WorkOrderNew와 완전히 동일 */}
                  <TinyMCEeditor height={400} editorRef={editorRef} />
                </div>
              }
            />
          </tr>

          {/* ===== 3) 검토결과 ===== */}
          <tr>
            <TableCell
              label="3) 검토결과"
              colSpan={3}
              editing={editing}
              value={<div className="p-1">{data.result || "-"}</div>}
              input={
                <textarea
                  name="result"
                  value={form.result || ""}
                  onChange={handleChange}
                  className="input-base h-24 resize-none"
                />
              }
            />
          </tr>
        </tbody>
      </table>
    </div>
  );
}
